import { useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { createBrandingSetup } from '@api/managePlatformBranding';

import { ICreateBrandingSetupsDTO } from '@interfaces/platform/dto/brandingDTO';

import { ESnackbarTypes } from '@enums/common';

import { BRANDING_SETUPS, CREATE_BRANDING_SETUP } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

interface ICreateSetupReturnType {
	handleCreateSetup: (dto: ICreateBrandingSetupsDTO) => void;
	isLoadingCreateSetup: boolean;
}

export const useMutateCreateBrandingSetup = (onSettledCallbacks?: Array<() => void>): ICreateSetupReturnType => {
	const dispatch = useAppDispatch();
	const queryClient = useQueryClient();

	const {
		mutate: handleCreateSetup,
		isLoading: isLoadingCreateSetup,
	} = useMutation<ICreateBrandingSetupsDTO>({
		mutationKey: [CREATE_BRANDING_SETUP],
		mutationFn: createBrandingSetup,
		onSuccess: () => {
			if (onSettledCallbacks?.length) {
				onSettledCallbacks.forEach((callback) => callback());
			}

			dispatch(setSnackbar({
				message: responseMessages.createBrandingSetup,
				type: ESnackbarTypes.success,
			}));

			return queryClient.invalidateQueries([BRANDING_SETUPS]);
		},
	});

	return {
		handleCreateSetup,
		isLoadingCreateSetup,
	};
};
